import * as firebase from 'firebase/app'
import 'firebase/auth'

// firebase init - add your own config here
const firebaseConfig = {
  apiKey: 'AIzaSyD8WXgIGyhhYPR_8KrHziXPS2YXcO7YdnA',
  authDomain: 'follow-app-255917.firebaseapp.com',
  databaseURL: 'https://follow-app-255917.firebaseio.com',
  projectId: 'follow-app-255917',
  storageBucket: 'follow-app-255917.appspot.com',
  messagingSenderId: '699381593874',
  appId: '1:699381593874:web:02e70097483e7d1399e5cb',
  measurementId: 'G-BNLJGJ5CXH',
}
firebase.initializeApp(firebaseConfig)

// utils
const auth = firebase.auth()
// auth.languageCode = 'zh_tw'

// export utils/refs
export default auth
